import { usePreserveForm } from "./usePreserveForm";
import { useRestoreLocation } from "./useRestoreLocation";
import { useSave } from "./useSave";
import { useRecoverForm } from "./useRecoverForm";

export const useFormStates = {
  // Track form changes and preserve them to redux store
  PreserveForm: usePreserveForm,

  // Save preserved form to DB
  Save: useSave,

  // Navigate user to the saved form location with the saved data
  // associated with it
  RestoreLocation: useRestoreLocation,

  // Read preserved form data from location state and recover the form
  RecoverForm: useRecoverForm,
};
